import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m14.84 8.72.69.55c.49.4.61 1.06.3 1.6l-1.36 2.27a1.3 1.3 0 0 1-1.57.54l-.83-.3a.97.97 0 0 0-1.3.73l-.14.85c-.1.6-.64 1.04-1.27 1.04H6.64c-.63 0-1.16-.44-1.27-1.04l-.14-.85a.97.97 0 0 0-1.3-.73l-.83.3a1.3 1.3 0 0 1-1.57-.54L.17 10.86c-.31-.53-.19-1.2.3-1.59l.69-.55a.92.92 0 0 0 0-1.44l-.69-.55a1.22 1.22 0 0 1-.3-1.6l1.36-2.27a1.3 1.3 0 0 1 1.57-.54l.83.3a.97.97 0 0 0 1.3-.73l.14-.85C5.47.44 6.01 0 6.64 0h2.72c.63 0 1.16.44 1.27 1.04l.14.85c.1.59.73.94 1.3.73l.83-.3a1.3 1.3 0 0 1 1.57.54l1.36 2.28c.31.53.19 1.2-.3 1.59l-.69.55a.92.92 0 0 0 0 1.44Zm-2.32 3.5.83.3 1.36-2.28-.69-.55a2.15 2.15 0 0 1 0-3.38l.69-.55-1.36-2.27-.83.3A2.26 2.26 0 0 1 9.5 2.1l-.14-.85H6.64l-.14.85a2.26 2.26 0 0 1-3.02 1.69l-.83-.3-1.36 2.27.69.55c1.1.88 1.1 2.5 0 3.38l-.69.55 1.36 2.27.83-.3A2.26 2.26 0 0 1 6.5 13.9l.14.85h2.72l.14-.85a2.26 2.26 0 0 1 3.02-1.69ZM11 8 6 5v6l5-3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }